import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import { useDialog } from "primevue/usedialog";
import { computed, ref } from "vue";

import RoleEditor from "@/components/Roles/RoleEditor.vue";
import type { Role } from "@/composables/role-manager";
import { useCurrentEntityManager } from "@/stores/entity-store";

import { useHotKeys } from "./hotkeys";

export const useEditRoleDialog = () => {
    const { domain } = useCurrentEntityManager();
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();
    const isVisible = computed(() => Boolean(dialogRef.value?.visible));

    const registerHotKey = () => {
        const { addHotKey } = useHotKeys();

        addHotKey(
            "n r",
            (e) => {
                if (!isVisible.value && domain.value?.identity) {
                    e.preventDefault();
                    open();
                }
            },
            "Open new role dialog."
        );
    };

    const open = (role?: Role): Promise<Role | undefined> => {
        return new Promise((resolve) => {
            dialogRef.value = dialog.open(RoleEditor, {
                props: {
                    header: role ? "Edit role" : "New role",
                    style: {
                        maxWidth: "600px",
                        width: "80%",
                    },
                    modal: true,
                    maximizable: false,
                    draggable: false,
                },
                data: role,
                onClose: (result?: { data?: { createdRole?: Role } }) => {
                    resolve(result?.data?.createdRole);
                },
            });
        });
    };

    return { registerHotKey, open, isVisible };
};
